/**
 * @description dom操作
 * @param {*} target
 */
function querySelector(target) {
  return document.querySelector(target);
}
export { querySelector };